export default __webpack_public_path__ + "static/media/img_sap_basis-colorBkg.b4fadc07.png";